"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    hasRunningActions: function (state) { return function (types) {
        if (types) {
            if (!Array.isArray(types)) {
                types = [types];
            }
            if (state.hasRunningActions) {
                for (var index in types) {
                    if (state.dispatches.hasOwnProperty(types[index])) {
                        return true;
                    }
                }
            }
            return false;
        }
        return state.hasRunningActions;
    }; }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0dGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdG9yZS9nZXR0ZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsa0JBQWU7SUFDYixpQkFBaUIsRUFBRSxVQUFBLEtBQUssSUFBSSxPQUFBLFVBQUEsS0FBSztRQUMvQixJQUFJLEtBQUssRUFBRTtZQUNULElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxFQUFFO2dCQUN6QixLQUFLLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQzthQUNqQjtZQUNELElBQUksS0FBSyxDQUFDLGlCQUFpQixFQUFFO2dCQUMzQixLQUFLLElBQUksS0FBSyxJQUFJLEtBQUssRUFBRTtvQkFDdkIsSUFBSSxLQUFLLENBQUMsVUFBVSxDQUFDLGNBQWMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRTt3QkFDakQsT0FBTyxJQUFJLENBQUM7cUJBQ2I7aUJBQ0Y7YUFDRjtZQUNELE9BQU8sS0FBSyxDQUFDO1NBQ2Q7UUFDRCxPQUFPLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQztJQUNqQyxDQUFDLEVBZjJCLENBZTNCO0NBQ0YsQ0FBQyJ9